export default "__VITE_ASSET__DVrkSY86__"